import type { RouteLocationNormalized, RouteLocationNamedRaw } from "vue-router";
import { parseDate } from "@/helpers/time";

const TIME_REPORT_NAME = "work-order-time-report-create";

function parseNumber(number: string): number | undefined {
  const parsed = parseFloat(number);
  return isNaN(parsed) ? undefined : parsed;
}

export const reportRoutes = [
  {
    path: "time-reports/create",
    name: TIME_REPORT_NAME,
    meta: {
      requiresAuth: true,
      title: "Skapa tidrapport",
    },
    props: (route: RouteLocationNormalized) => ({
      ...parseExpenseReportQuery(route.query),
      comment: typeof route.query.comment === "string" ? route.query.comment : undefined,
      hours: typeof route.query.hours === "string" ? parseNumber(route.query.hours) : undefined,
    }),
    component: () => import("@/modules/report/views/TimeReport.vue"),
  },
];

type ExpenseReportQuery = {
  date?: string;
  timeTypeId?: string;
};

export function parseExpenseReportQuery(query: RouteLocationNormalized["query"]): {
  date?: Date;
  timeTypeId?: string;
} {
  return {
    date: typeof query.date === "string" ? parseDate(query.date) : undefined,
    timeTypeId: typeof query.timeTypeId === "string" ? query.timeTypeId : undefined,
  };
}

export function getExpenseReportLink(workOrderId: string, timeReport?: ExpenseReportQuery): RouteLocationNamedRaw {
  return {
    name: "work-order-expense-report",
    params: { id: workOrderId },
    query: {
      create: "1",
      date: timeReport?.date,
      timeTypeId: timeReport?.timeTypeId,
    },
  };
}

export function getTimeReportLink(workOrderId: string, date?: string): RouteLocationNamedRaw {
  return {
    name: TIME_REPORT_NAME,
    params: { id: workOrderId },
    query: { date },
  };
}
